/*
 * @Author: jingfei
 * @Date: 2021-08-31 09:58:03
 * @LastEditTime: 2021-09-15 13:53:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \common-web\src\api\excel\excel.js
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;

const api = {
  // 创建模板配置
  saveConfiguration(data) {
    return request({
      url: `${requestUrl}/excel/template`,
      method: "post",
      data
    });
  },

  // 更新模板配置
  updateConfiguration(data) {
    return request({
      url: `${requestUrl}/excel/template`,
      method: "put",
      data
    });
  },

  // 数据源
  getDatasource(params) {
    return request({
      url: `${requestUrl}/datasource`,
      method: "get",
      params
    });
  },

  // // 修改模板配置
  // updateConfiguration(params){
  //   return request({
  //     url: `${requestUrl}/excel/template`,
  //     method: "put",
  //     params,
  //   });
  // },

  // 批量删除模板配置
  delteBatchConfiguration(data) {
    return request({
      url: `${requestUrl}/excel/template/delete-batch`,
      method: "post",
      data
    });
  },

  // 分页查询模板配置
  getConfigurationListOfPage(params) {
    return request({
      url: `${requestUrl}/excel/template/page`,
      method: "get",
      params
    });
  },

  // 根据id查询模板配置
  getConfigurationListOfId(id) {
    return request({
      url: `${requestUrl}/excel/template/${id}`,
      method: "get"
    });
  },

  // 根据id删除模板配置
  delteConfiguration(id) {
    return request({
      url: `${requestUrl}/excel/template/${id}`,
      method: "delete"
    });
  },

  // 附件上传
  updatingFiles(data) {
    return request({
      headers: { "Content-Type": "multipart/form-data" },
      url: `${requestUrl}/attachment/upload`,
      method: "post",
      data
    });
  },

  // 初始化sheet
  initSheet(templateId) {
    return request({
      url: `${requestUrl}/excel/template/${templateId}/sheet/init`,
      method: "post"
    });
  },

  // 查询模板sheet页集合
  getSheetBytemplateId(templateId) {
    return request({
      url: `${requestUrl}/excel/template/${templateId}/sheet`,
      method: "get"
    });
  },

  // 查询SheetColumn结构
  getSheetColumn(sheetId) {
    return request({
      url: `${requestUrl}/excel/template/sheet/${sheetId}/column`,
      method: "get"
    });
  },

  // 单条列数据保存
  saveColumn(data, sheetId) {
    return request({
      url: `${requestUrl}/excel/template/sheet/${sheetId}/column`,
      method: "post",
      data
    });
  },

  // 初始化列
  initColumn(sheetId) {
    return request({
      url: `${requestUrl}/excel/template/sheet/${sheetId}/column/init`,
      method: "post"
    });
  },

  // 自动匹配
  matchColumn(sheetId) {
    return request({
      url: `${requestUrl}/excel/template/sheet/${sheetId}/column/match`,
      method: "post"
    });
  },

  // 删除sheet列
  deleteColumn(columnId) {
    return request({
      url: `${requestUrl}/excel/template/sheet/column/${columnId}`,
      method: "delete"
    });
  },

  // 批量删除sheet列
  deletebatchColumn(data) {
    return request({
      url: `${requestUrl}/excel/template/sheet/column/delete-batch`,
      method: "post",
      data
    });
  },

  // 根据ID删除Sheet配置
  deleteSheet(sheetId) {
    return request({
      url: `${requestUrl}/excel/template/sheet/${sheetId}`,
      method: "delete"
    });
  },

  // 批量删除Sheet配置
  deletebatchSheet(data) {
    return request({
      url: `${requestUrl}/excel/template/sheet/delete-batch`,
      method: "post",
      data
    });
  },

  // 查询数据表
  getdatasource(datasourceId, tableName) {
    return request({
      url: `${requestUrl}/datasource/${datasourceId}/table/${tableName}/field`,
      method: "get"
    });
  },

  // 查询数据表集合
  getDataSources(datasourceId) {
    return request({
      url: `${requestUrl}/datasource/${datasourceId}/table`,
      method: "get"
    });
  },

  // 保存模板sheet页列配置
  saveSheetOfDatasource(data, templateId) {
    return request({
      url: `${requestUrl}/excel/template/${templateId}/sheet`,
      method: "patch",
      data
    });
  },

  // 保存模板sheet页列配置
  saveColumnOfproperty(data, sheetId) {
    return request({
      url: `${requestUrl}/excel/template/sheet/${sheetId}/column`,
      method: "patch",
      data
    });
  },

  // 根据ID查询附件记录
  getAttachmentRecord(attachmentId) {
    return request({
      url: `${requestUrl}/attachment/${attachmentId}`,
      method: "get"
    });
  },

  // 字典编码查询
  getCascadeDict() {
    return request({
      url: `${requestUrl}/dict/cascade-dict`,
      method: "get"
    });
  },

  // 附件下载
  downloadAttachment(id) {
    return request({
      url: `${requestUrl}/attachment/download/${id}`,
      method: "get",
      responseType: "blob"
    });
  }
};

export default api;
